import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';

import {
  TemplatesGetItemsResponse,
  TemplatesQueryParams,
} from 'hocs/templates/api/types';

import { TemplatesTabProps } from '../templatesTab';

type TemplatesSortingDropdownOwnProps = {
  disabled: boolean;
  templatesParamsChange: (
    params: TemplatesQueryParams,
  ) => Promise<TemplatesGetItemsResponse | void>;
  className?: string;
} & Pick<TemplatesTabProps, 'templateType'>;

type StateProps = {};

type TemplatesSortingDropdownProps = TemplatesSortingDropdownOwnProps &
  StateProps;

export class TemplatesSortingDropdown extends PureComponent<TemplatesSortingDropdownProps> {
  @boundMethod
  handleSortByNameAsc() {
    this.templatesSortChange('name:asc');
  }

  @boundMethod
  handleSortByNameDesc() {
    this.templatesSortChange('name:desc');
  }

  @boundMethod
  handleSortByCreatedAtAsc() {
    this.templatesSortChange('created_at:asc');
  }

  @boundMethod
  handleSortByCreatedAtDesc() {
    this.templatesSortChange('created_at:desc');
  }

  @boundMethod
  handleSortByLastEditedAtAsc() {
    this.templatesSortChange('last_edited_at:asc');
  }

  @boundMethod
  handleSortByLastEditedAtDesc() {
    this.templatesSortChange('last_edited_at:desc');
  }

  @boundMethod
  templatesSortChange(sortBy: string) {
    this.props.templatesParamsChange({
      sort_by: sortBy,
    });
  }

  render() {
    const { className, disabled } = this.props;

    return (
      <DropdownButton
        className={className}
        buttonProps={{ disabled }}
        dropdown={
          <ButtonList>
            <ButtonList.Item icon="arrow-up" onClick={this.handleSortByNameAsc}>
              A - Z
            </ButtonList.Item>
            <ButtonList.Item
              icon="arrow-down"
              onClick={this.handleSortByNameDesc}
            >
              Z - A
            </ButtonList.Item>
            <ButtonList.Divider />
            <ButtonList.Item
              icon="arrow-up"
              onClick={this.handleSortByCreatedAtAsc}
            >
              Created first
            </ButtonList.Item>
            <ButtonList.Item
              icon="arrow-down"
              onClick={this.handleSortByCreatedAtDesc}
            >
              Created last
            </ButtonList.Item>
            <ButtonList.Divider />
            <ButtonList.Item
              icon="arrow-up"
              onClick={this.handleSortByLastEditedAtAsc}
            >
              Updated first
            </ButtonList.Item>
            <ButtonList.Item
              icon="arrow-down"
              onClick={this.handleSortByLastEditedAtDesc}
            >
              Updated last
            </ButtonList.Item>
          </ButtonList>
        }
      >
        Sort by
      </DropdownButton>
    );
  }
}
